import { render, staticRenderFns } from "./MultiplechoiceModule.vue?vue&type=template&id=1ecf5793&scoped=true&"
import script from "./MultiplechoiceModule.vue?vue&type=script&lang=js&"
export * from "./MultiplechoiceModule.vue?vue&type=script&lang=js&"
import style0 from "./MultiplechoiceModule.vue?vue&type=style&index=0&id=1ecf5793&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecf5793",
  null
  
)

export default component.exports